import React from 'react';
import {Link} from 'react-router-dom';
import * as d3 from "./d3.modified.js"
import constants from '../ndbk-constants'
import {withRouter} from 'react-router-dom'

class AddNewGroup extends React.Component {

    constructor (props) {
        super(props)
        this.state = {
            groupNameInput : '',
            clicked : false
        }
    }
    componentDidMount() {
        d3.select(this.wrapper)
            .style('opacity', 0)
            .transition()
                .duration(500)
                .style('opacity', 1)
    }

    createGroup = () => {
        if (this.state.groupNameInput !== '' ) {
        fetch(`https://${constants.SERVER_IP}/api/group/create`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name: this.state.groupNameInput,//this.state.info.title,
                    description: '', //this.state.info.description,
                    visibility: 'public',//this.state.info.visibility
                })
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.props.history.push(`/group/${response.data.id}`);
                    }
                    return response.success;
                })
            .catch((error) => {
                    console.error(error)
            })
        }
    }

    render() {
        return (
            <div className="col-lg-4 col-md-6 col-sm-12">

                    <div className="group-preview" ref={c=>this.wrapper=c}>
                        {
                            (this.state.clicked)
                            ?<div style = {{display:'flex'}}>
                                <input
                                    style = {{
                                        flex:0.8
                                    }}
                                    type = "text"
                                    ref={c=>this.groupNameInputRef = c}
                                    value={this.state.groupNameInput}
                                    onChange={(e)=>{this.setState({groupNameInput: e.target.value})}}
                                    placeholder="Group name ... ">
                                </input>
                                <h1
                                    className="center create"
                                    onClick={this.createGroup}
                                    style = {{
                                        flex:0.2,
                                    }}>
                                    +
                                </h1>
                            </div>
                            :<h1 className="center" onClick={() => {
                                this.setState({clicked: true}, ()=>{
                                    this.groupNameInputRef.focus()
                                    })
                            }}>
                                + Create new group
                            </h1>
                        }
                        {/* <input type = "text" value={this.state.groupNameInput} onChange={(e)=>{this.setState({groupNameInput: e.target.value})}} placeholder="Group name ... "></input> */}
                        {/* <Link to="/new/group"> */}
                        {/* <h1 onClick={this.createGroup} className="center">
                            + Create new group
                        </h1> */}
                        {/* </Link> */}
                    </div>

            </div>
        )
    }
}

export default class PreviewGroup extends React.Component {
    componentDidMount() {
        d3.select(this.wrapper)
            .style('opacity', 0)
            .transition()
                .duration(500)
                .style('opacity', 1)
    }

    render() {
        return (
            <div className="col-lg-4 col-md-6 col-sm-12">
            <Link to={"/group/"+this.props.info.id} title={this.props.info.title}>
                <div className="group-preview" ref={c=>this.wrapper=c}>
                    <div className="avatar" style={{backgroundImage: `url(${this.props.info.avatar})`}}></div>
                    <h1>{this.props.info.name}
                        <small>{this.props.info.members} members &middot; {this.props.info.followers} followers</small>
                    </h1>
                    {/*<p>{this.props.info.description}</p>*/}
                </div>
            </Link>
            </div>
        )
    }
}

export {
    AddNewGroup,
    PreviewGroup
}



// WEBPACK FOOTER //
// ./src/components/PreviewGroup.js